import { render } from "./ManualList.vue?vue&type=template&id=bc5ad134"
import script from "./ManualList.vue?vue&type=script&lang=js"
export * from "./ManualList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__